










import { Component, Mixins, Prop } from "vue-property-decorator";
import { DataModules } from "@/store/modules/data";
import Context from "@/mixins/context";

@Component
export default class ULogLink extends Mixins(Context) {
  // Props
  @Prop({ required: true })
  public log!: any;

  // Props
  @Prop({ required: true })
  public title!: string;

  // Getters
  public get link() {
    return this.adminModalLink();
  }

  // Methods
  public adminModalLink() {
    return {
      type: "a",
      events: {
        click: () => {
          this.$store.dispatch(`data/${DataModules.LOGS}/openLogModal`, {
            props: { log: this.log, title: this.title }
          });
        }
      }
    };
  }
}
